import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
  standalone: true,
})
export class HighlightPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: string | undefined | null, textToHighlight: string | undefined): SafeHtml {
    if (!value) {
      return '';
    }
    if (!textToHighlight) {
      return value;
    }

    // Escape special characters in the search string
    const escapeRegExp = (str: string): string => str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

    const splitBySpace = textToHighlight
      .split(' ')
      .filter((word) => word !== '')
      .map(escapeRegExp); // Escape each word

    let highlighted = value;

    for (const word of splitBySpace) {
      const regex = new RegExp(`(${word})(?![^<]*?>)`, 'gi');
      highlighted = highlighted.replace(regex, (match) => `<span class="work-text-highlighted">${match}</span>`);
    }

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
